import React from "react";
import {
  CompanionsContainer,
  CompanionsCardContainer,
  CompanionsCard,
  CompanionsImageContainer,
  CompanionsCardLeft,
} from "./index.styled";
import mask from "../../assets/images/Mask.svg";
import Slider from "../Slider";

const Companions = () => {
  return (
    <CompanionsContainer id="customers">
      <h2>همراهان آواشو</h2>
      <CompanionsCardContainer>
        <CompanionsCard>
          <Slider />
        </CompanionsCard>
        <CompanionsImageContainer>
          <img src={mask} alt="mask" />
        </CompanionsImageContainer>
        <CompanionsCardLeft></CompanionsCardLeft>
      </CompanionsCardContainer>
    </CompanionsContainer>
  );
};

export default Companions;
